// @flow
import { getOr } from 'lodash/fp';
import { createSelector } from 'reselect';

const analytics = getOr({}, 'analytics');

export const frontEndAttemptID = createSelector(analytics, getOr(null, 'frontEndAttemptID'));
